export default __webpack_public_path__ + "static/media/logo.baeb7e6a.png";